import { parsePhoneNumber } from 'libphonenumber-js'

export const validateFullname = (name) => {
  const re = /^([a-z']+(-| )?)+$/i
  return name && re.test(name)
}

export const validatePhone = (number) => {
  return number.length >= 1 && number.length <= 30
}

export const validatePhoneLib = (number) => {
  try {
    return !!number && parsePhoneNumber(number).isValid()
  } catch (err) {
    return false
  }
}

export const validatePassword = (password) => {
  return password && password.length > 7
}

export const validateVatNumber = (number) => {
  return number.trim().length >= 1
}

export const validatePostalCode = (code) => {
  return code.trim().length > 3
}

export const validate4Digits = (code) => {
  return /^\d{4}$/.test(code)
}

export const validateDomain = (domain) => {
  const re =
    /^(?:https?:\/\/|s?ftps?:\/\/)?(?!www | www\.)[A-Za-z0-9_-]+\.+[A-Za-z0-9./%&=?_:;-]+$/
  return re.test(domain)
}
